const getConstants = require('../../../utils/getConstants');
const { repeaterFormItemTypes, repeaterCadenceTypes } = getConstants();

const kinds = {
   NOT_APPLICABLE: 'NOT_APPLICABLE',
   CANONICAL_ADD_ENTRIES: 'CANONICAL_ADD_ENTRIES',
   CANONICAL_FULL_LIST: 'CANONICAL_FULL_LIST',
   COMPATIBLE_NUMERIC_ADD_ENTRIES: 'COMPATIBLE_NUMERIC_ADD_ENTRIES',
   LEGACY_FOREACH: 'LEGACY_FOREACH',
   MALFORMED: 'MALFORMED'
};

const entryModes = {
   ADD_ENTRIES: 'ADD_ENTRIES',
   FULL_LIST: 'FULL_LIST'
};

const malformedReasonCodes = {
   REPEATER_TYPE_UNKNOWN: 'REPEATER_TYPE_UNKNOWN',
   REPEATER_ENTRY_MODE_UNKNOWN: 'REPEATER_ENTRY_MODE_UNKNOWN',
   REPEATER_ENTRY_MODE_NOT_ALLOWED_FOR_TYPE: 'REPEATER_ENTRY_MODE_NOT_ALLOWED_FOR_TYPE',
   LIST_REPEATER_ENTRY_MODE_REQUIRED: 'LIST_REPEATER_ENTRY_MODE_REQUIRED',
   LIST_REPEATER_FULL_LIST_FIELDS_CONFLICT: 'LIST_REPEATER_FULL_LIST_FIELDS_CONFLICT',
   LIST_REPEATER_ADD_ENTRIES_CADENCE_INVALID: 'LIST_REPEATER_ADD_ENTRIES_CADENCE_INVALID',
   LIST_REPEATER_ADD_ENTRIES_COUNT_INVALID: 'LIST_REPEATER_ADD_ENTRIES_COUNT_INVALID'
};

function matchesCanonicalId(value, id) {
   return value === id || value === String(id);
}

function isPositiveInteger(value) {
   if (Number.isInteger(value)) return value > 0;
   if (typeof value !== 'string') return false;
   const trimmed = value.trim();
   return /^\d+$/.test(trimmed) && Number(trimmed) > 0;
}

function isNumericCadence(value) {
   return [repeaterCadenceTypes.EXACTLY.id, repeaterCadenceTypes.AT_LEAST.id, repeaterCadenceTypes.AT_MOST.id].some((id) =>
      matchesCanonicalId(value, id)
   );
}

function isForeachCadence(value) {
   return matchesCanonicalId(value, repeaterCadenceTypes.FOREACH.id);
}

function result(kind, effectiveEntryMode, persistedEntryMode, malformedReasonCode = null) {
   return { kind, effectiveEntryMode, persistedEntryMode, malformedReasonCode };
}

function classifyRepeaterEntryMode({ idRepeaterType, entryMode, idRepeaterCadence, timesToRepeat }) {
   const isList = matchesCanonicalId(idRepeaterType, repeaterFormItemTypes.LIST.id);
   const isFreeFlow = matchesCanonicalId(idRepeaterType, repeaterFormItemTypes.FREE_FLOW.id);

   if (!isList && !isFreeFlow) {
      return result(kinds.MALFORMED, null, entryMode, malformedReasonCodes.REPEATER_TYPE_UNKNOWN);
   }

   if (isFreeFlow) {
      const hasNoEntryMode = entryMode == null;
      if (hasNoEntryMode && !isForeachCadence(idRepeaterCadence)) {
         return result(kinds.NOT_APPLICABLE, null, entryMode);
      }
      return result(kinds.MALFORMED, null, entryMode, malformedReasonCodes.REPEATER_ENTRY_MODE_NOT_ALLOWED_FOR_TYPE);
   }

   // Compatibility states are intentionally recognised before canonical malformed checks.
   if (entryMode == null && isForeachCadence(idRepeaterCadence)) {
      return result(kinds.LEGACY_FOREACH, null, entryMode);
   }
   if (entryMode == null && isNumericCadence(idRepeaterCadence) && isPositiveInteger(timesToRepeat)) {
      return result(kinds.COMPATIBLE_NUMERIC_ADD_ENTRIES, entryModes.ADD_ENTRIES, entryMode);
   }

   if (entryMode !== undefined && entryMode !== null && entryMode !== entryModes.ADD_ENTRIES && entryMode !== entryModes.FULL_LIST) {
      return result(kinds.MALFORMED, null, entryMode, malformedReasonCodes.REPEATER_ENTRY_MODE_UNKNOWN);
   }

   if (entryMode == null) {
      return result(kinds.MALFORMED, null, entryMode, malformedReasonCodes.LIST_REPEATER_ENTRY_MODE_REQUIRED);
   }

   if (entryMode === entryModes.FULL_LIST) {
      if (idRepeaterCadence != null || timesToRepeat != null) {
         return result(kinds.MALFORMED, null, entryMode, malformedReasonCodes.LIST_REPEATER_FULL_LIST_FIELDS_CONFLICT);
      }
      return result(kinds.CANONICAL_FULL_LIST, entryModes.FULL_LIST, entryMode);
   }

   if (!isNumericCadence(idRepeaterCadence)) {
      return result(kinds.MALFORMED, null, entryMode, malformedReasonCodes.LIST_REPEATER_ADD_ENTRIES_CADENCE_INVALID);
   }
   if (!isPositiveInteger(timesToRepeat)) {
      return result(kinds.MALFORMED, null, entryMode, malformedReasonCodes.LIST_REPEATER_ADD_ENTRIES_COUNT_INVALID);
   }
   return result(kinds.CANONICAL_ADD_ENTRIES, entryModes.ADD_ENTRIES, entryMode);
}

module.exports = classifyRepeaterEntryMode;
module.exports.kinds = kinds;
module.exports.entryModes = entryModes;
module.exports.malformedReasonCodes = malformedReasonCodes;
module.exports.matchesCanonicalId = matchesCanonicalId;
